import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import {
  permitKeys,
  RequestTypes,
} from '@core/react-query/features/permits/permit'
import { IPermit, Permit } from '@core/entities/permit/Permit'
import { RequestErrorType } from '@core/utils/api-axios-instance'

const permitTransform = (data) => {
  try {
    const permit = Permit.new(data)
    return permit
  } catch (error) {
    // Looks like that sometimes select doesn't return Permit entity.
    // This is a temporary notify to see if Permit.new ever throws an error, so RQ returns plain JS object.
    // https://siteassist-fq.sentry.io/issues/127461105/?project=4508799743885392&query=is%3Aunresolved&referrer=issue-stream
    API.errorTracking.notify(error)
    throw error
  }
}

export const usePermitById = (
  payload: RequestTypes['getPermit'],
  options?: UseQueryOptions<IPermit, RequestErrorType, Permit>,
) =>
  useQuery({
    select: permitTransform,
    ...permitKeys.byId(payload),
    ...options,
  })
